module.exports = __webpack_public_path__ + "static/media/logo_gate13.5c8ce2d3.png";